const googleMaps = () => {
	const mapStyles = [
		{
			featureType: "water",
			elementType: "geometry",
			stylers: [
				{
					color: "#e9e9e9",
				},
				{
					lightness: 17,
				},
			],
		},
		{
			featureType: "landscape",
			elementType: "geometry",
			stylers: [
				{
					color: "#f5f5f5",
				},
				{
					lightness: 20,
				},
			],
		},
		{
			featureType: "road.highway",
			elementType: "geometry.fill",
			stylers: [
				{
					color: "#ffffff",
				},
				{
					lightness: 17,
				},
			],
		},
		{
			featureType: "road.highway",
			elementType: "geometry.stroke",
			stylers: [
				{
					color: "#ffffff",
				},
				{
					lightness: 29,
				},
				{
					weight: 0.2,
				},
			],
		},
		{
			featureType: "road.arterial",
			elementType: "geometry",
			stylers: [
				{
					color: "#ffffff",
				},
				{
					lightness: 18,
				},
			],
		},
		{
			featureType: "road.local",
			elementType: "geometry",
			stylers: [
				{
					color: "#ffffff",
				},
				{
					lightness: 16,
				},
			],
		},
		{
			featureType: "poi",
			elementType: "geometry",
			stylers: [
				{
					color: "#f5f5f5",
				},
				{
					lightness: 21,
				},
			],
		},
		{
			featureType: "poi.park",
			elementType: "geometry",
			stylers: [
				{
					color: "#dedede",
				},
				{
					lightness: 21,
				},
			],
		},
		{
			elementType: "labels.text.stroke",
			stylers: [
				{
					visibility: "on",
				},
				{
					color: "#ffffff",
				},
				{
					lightness: 16,
				},
			],
		},
		{
			elementType: "labels.text.fill",
			stylers: [
				{
					saturation: 36,
				},
				{
					color: "#333333",
				},
				{
					lightness: 40,
				},
			],
		},
		{
			elementType: "labels.icon",
			stylers: [
				{
					visibility: "off",
				},
			],
		},
		{
			featureType: "transit",
			elementType: "geometry",
			stylers: [
				{
					color: "#f2f2f2",
				},
				{
					lightness: 19,
				},
			],
		},
		{
			featureType: "administrative",
			elementType: "geometry.fill",
			stylers: [
				{
					color: "#fefefe",
				},
				{
					lightness: 20,
				},
			],
		},
		{
			featureType: "administrative",
			elementType: "geometry.stroke",
			stylers: [
				{
					color: "#fefefe",
				},
				{
					lightness: 17,
				},
				{
					weight: 1.2,
				},
			],
		},
	]

	/**
	 * initMap
	 *
	 * Renders a Google Map onto the selected jQuery element
	 *
	 * @date    22/10/19
	 * @since   5.8.6
	 *
	 * @param   jQuery $el The jQuery element.
	 * @return  object The map instance.
	 */
	const initMap = ($el) => {
		// Find marker elements within map.
		let $markers = $el.find(".marker")

		// Create gerenic map.
		let mapArgs = {
			zoom: $el.data("zoom") || 16,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			// styles: mapStyles,
		}
		let map = new google.maps.Map($el[0], mapArgs)

		// Add markers.
		map.markers = []
		$markers.each((index, target) => {
			initMarker($(target), map)
		})

		// Center map based on markers.
		centerMap(map)

		// Return map instance.
		return map
	}

	/**
	 * initMarker
	 *
	 * Creates a marker for the given jQuery element and map.
	 *
	 * @date    22/10/19
	 * @since   5.8.6
	 *
	 * @param   jQuery $el The jQuery element.
	 * @param   object The map instance.
	 * @return  object The marker instance.
	 */
	const initMarker = ($marker, map) => {
		// Get position from marker.
		let latLng = {
			lat: $marker.data("lat"),
			lng: $marker.data("lng"),
		}

		// If there is map data, but not geolocation - bail!
		if (!latLng.lat || !latLng.lng) return

		// Create marker instance.
		let marker = new google.maps.Marker({
			position: latLng,
			map: map,
			icon: "/dist/images/map-marker.svg",
			title: "Full Address",
		})

		const fullAddress =
			"<div class='p-4 text-plum max-w-sm text-base md:text-lg font-normal text-center'>" +
			$marker.data("add") +
			"</div>"

		// Append to reference for later use.
		map.markers.push(marker)

		// If marker contains HTML, add it to an infoWindow.
		if (fullAddress) {
			// Create info window.
			let infowindow = new google.maps.InfoWindow({
				content: fullAddress,
			})

			// Show info window by default
			infowindow.open(map, marker)
		}
	}

	/**
	 * centerMap
	 *
	 * Centers the map showing all markers in view.
	 *
	 * @date    22/10/19
	 * @since   5.8.6
	 *
	 * @param   object The map instance.
	 * @return  void
	 */
	const centerMap = (map) => {
		// Create map boundaries from all map markers.
		const bounds = new google.maps.LatLngBounds()
		map.markers.forEach((marker) => {
			bounds.extend({
				lat: marker.position.lat(),
				lng: marker.position.lng(),
			})
		})

		// Case: Single marker.
		if (map.markers.length == 1) {
			map.setCenter(bounds.getCenter())

			// Case: Multiple markers.
		} else {
			map.fitBounds(bounds)
		}
	}

	// Render maps on page load if not lazyload
	$(`.g-map[data-lazyload="false"]`).each((index, target) => {
		if (!$(target).length) return
		initMap($(target))
	})

	// Init once when triggered
	$(`[data-init-map]`).each((index, target) => {
		const $target = $(target)
		$target.on("click", ({ currentTarget }) => {
			if ($target.attr("data-map-initialised") == "true") return
			$target.attr("data-map-initialised", "true")
			initMap(
				$(`#${$(currentTarget).attr("data-init-map")}`).find(".g-map")
			)
		})
	})

	// Init Map when load
	const searchParams = new URLSearchParams(window.location.search)
	if (searchParams.has("id") && searchParams.get("id")?.length > 0) {
		const btntarget = document.querySelector(
			`[data-init-map="location-${searchParams.get("id")}"]`
		)
		const target = document.querySelector(
			`#location-${searchParams.get("id")}`
		)
		if (target) {
			const $target = $(target)
			$target.attr("data-map-initialised", "true")
			btntarget.setAttribute("data-map-initialised", true)
			initMap($(`#${$(btntarget).attr("data-init-map")}`).find(".g-map"))
		}
	}
}

window.googleMaps = googleMaps
